module.exports = __webpack_public_path__ + "fda8e075ad1b13bc7d88a9e760e10d05.png";